import { useQuery } from 'react-query';
import { getAudits, getAudit } from '@/services/audit';
import type { FilterType } from '@/types/table';

/**
 * React Query hook for fetching paginated audit records
 * Supports filtering, sorting, and searching
 * Used by Audit table component
 */
export const useGetAudits = ({
	page = 1,
	limit = 15,
	enabled = true,
	columnsFilters = '[]',
	search = '',
	status = '',
	globalFilters = '[]',
	sort = '',
}: FilterType) => {
	return useQuery({
		queryKey: [
			'audits',
			page,
			limit,
			columnsFilters,
			search,
			status,
			globalFilters,
			sort,
		],
		queryFn: () =>
			getAudits(
				page,
				limit,
				columnsFilters,
				search,
				status as string,
				globalFilters as string,
				sort as string,
			),
		enabled,
		keepPreviousData: false,
	});
};

/**
 * React Query hook for fetching single audit record by ID
 * Used by Audit details modal
 */
export const useGetAudit = (id: number | null, enabled = true) =>
	useQuery({
		queryKey: ['audit', id],
		queryFn: () => getAudit(id as number),
		enabled: enabled && !!id,
		keepPreviousData: false,
	});

